
import React, { useEffect, useState, useRef } from "react";

import { CircularProgress } from "@mui/material";
import request from "../utils/request";

function Calendly() {

  const [loading, setLoading] = useState(false);
  const [showEmbed, setShowEmbed] = useState(false);
  const [stripeLoading, setStripeLoading] = useState(false);
  const [showStripeLink, setShowStripeLink] = useState(false);

  const loadCalendlyScript = () => {
    const existingScript = document.querySelector(
      'script[src="https://assets.calendly.com/assets/external/widget.js"]'
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  };

  useEffect(() => {
    if (showEmbed) {
      loadCalendlyScript();
    }
  }, [showEmbed]);


  const updateOnboarding = async () => {
    setLoading(true);
    try {
      await request.post("/hosts/onboardingbooked-status");

      setShowStripeLink(true);
    } catch (err) {
      console.error("Error updating onboarding status", err);

    }
    setLoading(false);
  };


  const handleScheduleClick = async () => {
    await updateOnboarding();
    setShowEmbed(true);
  };

  const handleStripeClick = async () => {
    setStripeLoading(true);
    try {
      const { data } = await request.get("/stripe/get-onboarding-link");
      window.location.href = data.url;
    } catch (error) {
      console.error("Error getting Stripe onboarding link:", error);
    }
    setStripeLoading(false);
  };

  if (!showEmbed) {
    return (
      <div className="flex flex-col items-center justify-center gap-6">
        <div className="flex flex-row gap-4">
          <button
            onClick={handleScheduleClick}
            className="bg-primary text-white py-2 px-4 rounded w-40"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Schedule a Call"}
          </button>
          <button
            onClick={updateOnboarding}
            className="bg-primary text-white py-2 px-4 rounded w-40"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "No Thanks"}
          </button>
        </div>

        {showStripeLink && (
          <button
            onClick={handleStripeClick}
            className="bg-primary text-white py-2 px-4 rounded w-48"
            disabled={stripeLoading}
          >
            {stripeLoading ? <CircularProgress size={20} /> : "Link Stripe Account"}
          </button>
        )}

      </div>
    );
  }


  return (
    <div className="flex flex-col items-center justify-center gap-6">
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/alex-bellhopt"
        style={{ minWidth: "320px", height: "400px" }}
      ></div>

      {showStripeLink && (
        <button
          onClick={handleStripeClick}
          className="bg-primary text-white py-2 px-4 rounded w-48"
          disabled={stripeLoading}
        >
          {stripeLoading ? <CircularProgress size={20} /> : "Link Stripe Account"}
        </button>
      )}

    </div>
  );
}

export default Calendly;
